import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { getPublicMenuPath } from '@/lib/tenant/getPublicMenuPath';

export default function CheckoutDemoFooter({ routeBid, primaryColor }) {
  return (
    <>
      <div className="flex flex-col sm:flex-row flex-wrap gap-3 justify-stretch">
        <Button variant="outline" className="flex-1 min-w-[140px]" asChild>
          <Link to="/register">Crear mi menú</Link>
        </Button>
        <Button className="flex-1 min-w-[140px] bg-violet-600 hover:bg-violet-600/90" asChild>
          <Link to="/pricing">Ver planes</Link>
        </Button>
        <Button variant="secondary" className="flex-1 min-w-[140px]" asChild>
          <Link to={getPublicMenuPath(routeBid, 'assistant')}>Probar asistente</Link>
        </Button>
      </div>

      <Card className="p-5 sm:p-6 border-border bg-muted/30">
        <p className="text-lg font-semibold tracking-tight text-foreground">
          Tu restaurante podría verse así en menos de 1 hora.
        </p>
        <p className="text-sm text-muted-foreground mt-2">
          Mismo flujo que SoluQR: catálogo, productos, asistente y checkout.
        </p>
        <div className="mt-4 flex flex-col sm:flex-row gap-3">
          <Button className="flex-1" style={{ backgroundColor: primaryColor }} asChild>
            <Link to="/register">Crear mi menú</Link>
          </Button>
          <Button variant="outline" className="flex-1" asChild>
            <Link to="/pricing">Ver planes</Link>
          </Button>
        </div>
      </Card>
    </>
  );
}
